import React from "react";
import ReactDOM from "react-dom/client";

import {
  HelmetProvider,
} from "react-helmet-async";

import App from "./App";
import { savePublicCache } from "./utils/publicDataCache";

import "./styles/design-system.css";
import "./index.css";

/*
 * cPanel PHP renderers can embed the exact public dataset used to build the
 * initial crawlable HTML. Seed the existing cache before React mounts so the
 * first client render does not immediately depend on a cross-origin API XHR.
 */
const bootstrap = window.__NEXROJGAR_BOOTSTRAP__;

if (
  bootstrap &&
  typeof bootstrap === "object" &&
  typeof bootstrap.cacheKey === "string" &&
  bootstrap.cacheKey.trim() &&
  Object.prototype.hasOwnProperty.call(bootstrap, "data")
) {
  savePublicCache(bootstrap.cacheKey, bootstrap.data);
}

try {
  delete window.__NEXROJGAR_BOOTSTRAP__;
} catch {
  window.__NEXROJGAR_BOOTSTRAP__ = undefined;
}

const rootElement =
  document.getElementById("root");

if (!rootElement) {
  throw new Error(
    'Root element with id "root" was not found.',
  );
}

const root =
  ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);